import React from 'react'
import { Link } from 'gatsby'

const BackButton = ({component}) => {
    const target =
        component === 'vacancy' ? '/about-us/join-us/'
        : '/knowledge-centre/?page=1'

    const text = component === 'vacancy' ? 'Work with us' : 'Knowledge Centre'

    return (
        <Link to={target} className="!font-semibold !text-darkblue hover:!text-brightgreen text-[11px] tracking-[1px] uppercase py-2 pr-2 mb-12 inline-block duration-300">
            <i className="fa fa-regular fa-chevron-left w-2 mr-2 text-[11px]"></i>
            {text}
        </Link>
    )
}

export default BackButton